import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    location: null,
}

const navigation_slice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        setLocation: (state, action) => {
            state.location = action.payload
        }
    }
})

export const { setLocation } = navigation_slice.actions;
export default navigation_slice.reducer;